/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".sbc-tooltip{position:absolute;background:#f5f5f5;padding:.25rem;white-space:pre;border-radius:.25rem;display:none;z-index:10}.sbc-bar-label{font-size:smaller;text-anchor:end}.sbc-seg-label{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;pointer-events:none;font-size:smaller}.sbc-debug{white-space:normal}"];
export { styles as styles };
